<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 194.461"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M54.164 60.635c-1.941,22.891 2.559,46.83 13.5,71.82 -18.62,-32.238 -24.725,-56.253 -18.317,-72.046 1.238,0.127 2.553,0.084 4.817,0.226z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M85.868 13.219c-5.652,-5.613 -10.45,-5.048 -18.207,-2.8 -5.571,2.867 -11.233,3.528 -19.105,1.184 -6.995,-3.557 -13.449,-5.316 -19.361,-5.276 -8.56,-0.387 -15.304,1.972 -18.809,8.004 22.991,6.048 41.48,8.142 55.468,6.28 8.229,-1.095 14.901,-3.559 20.014,-7.392z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M85.868 13.219c-5.113,3.833 -11.785,6.297 -20.014,7.392 -1.891,8.393 -1.612,15.821 0.837,22.282 8.708,1.359 17.237,3.646 25.589,6.862 6.593,-14.073 2.607,-29.295 -6.412,-36.536z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M66.789 42.797c-17.733,-2.766 -36.203,-1.68 -55.409,3.261 0.413,0.887 0.873,1.769 1.384,2.652 0.673,1.162 1.436,2.326 2.298,3.503 2.23,2.525 6.676,3.94 11.011,2.235 5.558,-2.188 5.599,-3.074 10.587,-3.174 5.734,0.104 10.604,-0.206 15.457,-0.088 11.36,0.278 18.377,-0.422 23.688,1.781 6.934,2.876 11.625,2.48 15.741,-1.501 0.275,-0.61 0.553,-1.212 0.832,-1.807 -8.352,-3.216 -16.881,-5.503 -25.589,-6.862z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M39.45 41.639c0.181,-4.44 0.059,-11.604 -0.364,-21.494 -8.627,-1.112 -18.194,-3.05 -28.7,-5.814 -1.212,2.085 -2.037,4.609 -2.416,7.611 -0.29,10.091 0.091,17.299 3.312,24.212 9.573,-2.462 18.961,-3.967 28.168,-4.515z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M39.086 20.145c0.423,9.89 0.545,17.054 0.364,21.494 9.266,-0.552 18.346,-0.133 27.241,1.254 -2.449,-6.461 -2.728,-13.889 -0.837,-22.282 -7.596,1.011 -16.518,0.856 -26.768,-0.466z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M12.671 48.96c1.071,33.679 12.55,62.712 34.47,88.154 14.903,17.269 30.46,17.108 32.055,-15.992 -0.619,-35.617 6.25,-56.81 13.492,-72.27 6.593,-14.073 2.199,-28.392 -6.82,-35.633 -5.652,-5.613 -10.45,-5.048 -18.207,-2.8 -5.571,2.867 -11.233,3.528 -19.105,1.184 -6.995,-3.557 -13.449,-5.316 -19.361,-5.276 -11.519,-0.521 -19.75,3.931 -21.225,15.615 -0.376,13.091 0.377,21.329 6.994,30.367 2.23,2.525 6.676,3.94 11.011,2.235 5.558,-2.188 5.599,-3.074 10.587,-3.174 5.734,0.104 10.604,-0.206 15.457,-0.088 11.36,0.278 18.377,-0.422 23.688,1.781 6.989,2.899 11.7,2.473 15.839,-1.597"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
